export default __webpack_public_path__ + "static/media/twitter.ab5c408e.svg";